import  { useState } from "react";
import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import { Box, useTheme,  Typography, Divider, Button, Grid, Card } from "@mui/material";
import { tokens } from "../../../theme/theme";
import { useTranslation } from "react-i18next";
import qrcode from 'qrcode';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";

const LabelReamDetails = ({ qrCodeValue, ProductDetail, company_id }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const userPermissions = useUserPermissions();

    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/Assets/images/ITC_logo.png',

    });

    function formatDate(dateString) {
        if (!dateString) return ''; // Handle null or undefined date
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
        const year = date.getFullYear(); // Get full year
        return `${day}/${month}/${year}`;
    }


    // call print QR Code
    const handleButtonClick = async (ream_number) => {

        let isvalid = true;

        const reamdet = ProductDetail.find(
            (detail) => detail.ream_number === ream_number
        );

        if (reamdet.ream_number === '') {
            isvalid = false;
        }


        if (isvalid == true) {


            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code parentRollNumber
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(reamdet.pallet_code);
                // Check if QR code generation was successful
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', reamdet.pallet_code);
                }

                if (company_id === '1') {
                    // Write HTML content for the QR code to the print window
                    printWindow.document.write(`

                                                <html>
                                                    <head>
                                                        <title>Printed Report</title>
                                                        <style>
                                                                body {
                                                                    margin: 0;
                                                                    padding: 0;
                                                                    font-family: Arial, sans-serif;
                                                                }
                                                                .container {
                                                                    display: flex;
                                                                    align-items: center;
                                                                    justify-content: space-between;
                                                                    padding: 10px;
                                                                    border: 1px solid #ccc;
                                                                    box-sizing: border-box;
                                                                }
                                                                .qr-code {
                                                                    width: 150px; /* Adjust as needed */
                                                                }
                                                                .bundle-details {
                                                                    flex: 1;
                                                                    margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                                                }
                                                                .bundle-details h5 {
                                                                    margin: 0;
                                                                    font-size: 18px;
                                                                }
                                                                .details-table {
                                                                    display: grid;
                                                                    grid-template-columns: 150px auto;
                                                                    gap: 10px 20px;
                                                                    margin-top: 10px;
                                                                }
                                                                .details-table div {
                                                                    font-size: 16px;
                                                                }
                                                                .details-table .label {
                                                                    font-weight: bold;
                                                                }
                                                                .bundle-details hr {
                                                                    margin: 10px 0;
                                                                    border: 1px solid #ccc;
                                                                }
                                                                /* Ensure each container goes on a new page */
                                                                .container {
                                                                    page-break-after: always;
                                                                }
                                                            </style>
                                                    </head>
                                                    <body>
                                                    <div class="container">
                                                    <div>
                                                        <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                                        <h3>${reamdet.ream_number || 'XXXXXX0123'}</h3>
                                                    </div>
                                                    <div class="bundle-details">
                                                    
                                                            <h5>REAM DETAILS</h5>
                                                            <hr/>
                                                    <div class="details-table">
                                                            <div class="label">DATE / SHIFT </div><div>:  ${reamdet.shift_date || ''} / ${reamdet.shift_code || ''}</div>  
                                                            <div class="label">REAM NUMBER</div><div>: ${reamdet.ream_number}</div> 
                                                            <div class="label">PALLET CODE</div><div>: ${reamdet.pallet_code}</div> 
                                                            <div class="label">REEL NUMBER</div><div>: ${reamdet.cr_number}</div> 
                                                            <div class="label">QUALITY</div><div>: ${reamdet.item_code}</div> 
                                                            <div class="label">SIZE</div><div>: ${reamdet.size}</div>  
                                                            <div class="label">GSM</div><div>: ${reamdet.gsm}</div> 
                                                            <div class="label">REAM WEIGHT</div><div>: ${reamdet.ream_weight}</div> 
                                                            <div class="label">NO.OF.SHEETS</div><div>: ${reamdet.no_of_sheets}</div> 
                                                            <div class="label">REMARKS</div><div>:</div>            
                                                        
                                                        </div>
                                                        
                                                        
                                                        
                                                    </div>
                                                    
                                                </div>
                                                    </body>
                                                </html>


                                                
                                            `);
                }
                else if (company_id === '13') {

                    printWindow.document.write(`
                        <html>
                        <head>
                            <title>Printed Report</title>
                            <style>
                                @page {
                                     size: 100mm 25mm; /* Portrait orientation */
                                         margin: 0; /* Remove margins for edge-to-edge printing */
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                    display: flex;
                                    flex-wrap: wrap; /* Allows multiple labels on the same page */
                                    align-items: flex-start;
                                    justify-content: flex-start;
                                    
                                    box-sizing: border-box;
                                }
                                .container {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 100%;
                                    height: 45px;
                                    padding: 0; /* Remove padding from the container */
                                    box-sizing: border-box;
                                }
                                .labelx {
                                    width: 100mm;
                                    height: 25mm;
                                    padding: 2mm; /* Adjust as needed for content alignment */
                                    box-sizing: border-box;
                                   
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                .logo {
                                    max-width: 7mm; /* Ensure logo scales within a small area */
                                    height: auto;
                                   
                                }
                                .text-details {
                                    flex: 1;
                                    margin-left: 1mm;
                                    margin-top: 0.2mm;
                                    font-size: 0.4rem;
                                    font-weight: bold;
                                }
                                .text-details p {
                                    margin: 0;
                                    line-height: 1.1; /* Reduce line spacing for compactness */
                                    font-weight: bold;
                                    color: #01579b;
                                }
                                .marketed-by {
                                    text-align: center;
                                    font-size: 0.3rem;
                                    font-weight: bold;
                                    margin-top: 0.5mm; /* Reduce or remove space above */
                                }
                                .marketed-by p {
                                    margin: 0; /* Remove margins from paragraphs */
                                    line-height: 1.1; /* Compact line spacing */
                                }
                                .details-section {
                                    display: grid;
                                    grid-template-columns: auto auto; /* Label and value in two columns */
                                    gap: 0.1mm 0.1mm; /* Reduce spacing between rows and columns */
                                    width: 100%;                                   
                                    margin-top: 0.5mm;
                                    
                                }
                                .details-section .label {
                                    font-weight: bold;
                                    text-align: left;
                                     font-size: 0.7rem;
                                }
                               .details-section .label1 {                                    
                                    text-align: left;
                                     font-weight: bold;
                                     font-size: 0.6rem;
                                }
                                .details-section .value {
                                    text-align: left;
                                    font-size: 0.7rem;
                                }
                                .details-section .value1 {
                                    text-align: left;
                                    font-size: 0.6rem;
                                }
                                .details-section .full-line {
                                    text-align: left; /* Center align the text */
                                    font-size: 0.9rem; /* Adjust font size for readability */
                                    font-weight: bold; /* Bold text for emphasis */
                                    text-transform: uppercase; /* Ensure the text is all caps */
                                    width: 100%; /* Span the full width of the container */
                                    grid-column: 1 / -1; /* Make it span across both columns in the grid */
                                    margin-top: 0mm; /* Optional: Add spacing above for better layout */
                                    white-space: nowrap; /* Prevent wrapping to a new line */
                                }    
                            </style>
                        </head>
                       <body>
                       <div class="labelx">
                       <div class="header-row" ">
                                    <!-- Logo -->
                                    <div class="container">
                                        <!-- Logo Section -->
                                        <div>
                                           
                                        </div>

                                        <!-- Text Details -->
                                        <div class="text-details">
                                           
                                        </div>
                                    </div>

                                    
                        
                                <!-- Marketed By Section -->
                                <div class="marketed-by">
                                    
                                </div>
                      </div>

                            
                                
                         <!-- Details Section -->
                                 
                                    <div>
                                        <table style="text-align: left; font-size: 10px; border-collapse: collapse;">
                                            <tr>
                                                <!-- Column 1 -->
                                                <th style="padding-right: 1px;">
                                                    <table style="text-align: left; font-size: 10px;">
                                                        <tr>
                                                            <th>${reamdet.item_code}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>GSM:</th>
                                                            <th>${reamdet.gsm}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>SIZE(cm):</th>
                                                            <th>${reamdet.size}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>NET WT(kg):</th>
                                                            <th>${reamdet.ream_weight}</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="visibility: hidden;">F.NO:</th> 
                                                            <th style="visibility: hidden;">${reamdet.fno || 0}</th>
                                                        </tr>
                                                    </table>
                                                </th>

                                                <!-- Column 2 -->
                                                <th>
                                                    <table style="text-align: left; font-size: 10px;">
                                                        <tr>
                                                            <th>DATE:</th>
                                                            <th>${formatDate(reamdet.shift_date)}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>LOT NO:</th>
                                                            <th>${reamdet.pr_number}</th>
                                                        </tr>
                                                        <tr>
                                                            <th></th>
                                                            <th>/ ${reamdet.cr_number}</th>
                                                        </tr>
                                                        <tr>
                                                            <th>NO OF SHEET:</th>
                                                            <th> ${reamdet.no_of_sheets || 0}</th>
                                                        </tr>
                                                        <tr style="font-size: 12px;">
                                                            <th>MADE IN INDIA</th>
                                                        
                                                        </tr>
                                                    
                                                    </table>
                                                </th>
                                            </tr>
                                        </table>
                                    </div>
                                 
    
                                   
 
                                   
                                </div>

                                
                           </div>
                        </body>
                        </html>
                        `);


                }
                else if (company_id === 3) {
                    printWindow.document.write(`

                        <html>
                        <head>
                            <title>Label Printing</title>
                            <style>
                                @page {
                                    size: A4;
                                    margin: 0; /* Remove margins for edge-to-edge printing */
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                    display: flex;
                                    flex-wrap: wrap; /* Allows multiple labels on the same page */
                                    align-items: flex-start;
                                    justify-content: flex-start;
                                    
                                    box-sizing: border-box;
                                }
                                .label {
                                    width: 100mm;
                                    height: 25mm;
                                    padding: 2mm; /* Adjust as needed for content alignment */
                                    box-sizing: border-box;
                                    border: 1px solid #000; /* Optional: For testing boundaries */
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                }

                                .container {
                                    display: flex;
                                   
                                    justify-content: space-between;
                                    width: 100%;
                                    height: 35px;
                                    padding: 0; /* Remove padding from the container */
                                    box-sizing: border-box;
                                }

                                 .logo {
                                        max-width: 7mm; /* Ensure logo scales within a small area */
                                        height: auto;
                                       
                                    }
                                    .text-details {
                                        flex: 1;
                                        margin-left: 1mm;
                                        margin-top: 0.2mm;
                                        font-size: 0.4rem;
                                        font-weight: bold;
                                    }
                                    .text-details p {
                                        margin: 0;
                                        line-height: 1.1; /* Reduce line spacing for compactness */
                                        font-weight: bold;
                                        color: #01579b;
                                    }
                                    .marketed-by {
                                        text-align: center;
                                        font-size: 0.3rem;
                                        font-weight: bold;
                                        margin-top: 2mm; /* Reduce or remove space above */
                                    }
                                    .marketed-by p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 1.1; /* Compact line spacing */
                                    }
                                    .details-section {
                                        display: grid;
                                        grid-template-columns: auto auto; /* Label and value in two columns */
                                        gap: 0.5mm 2mm; /* Reduce spacing between rows and columns */
                                        width: 100%;
                                       
                                        margin-top: 0.5mm;
                                        
                                    }
                                    .details-section .label {
                                        font-weight: bold;
                                        text-align: left;
                                         font-size: 0.7rem;
                                    }
                                   .details-section .label1 {
                                        font-weight: bold;
                                        text-align: left;
                                         font-size: 0.6rem;
                                    }
                                    .details-section .value {
                                        text-align: left;
                                        font-size: 0.7rem;
                                    }
                                    .details-section .value1 {
                                        text-align: left;
                                        font-size: 0.6rem;
                                    }
                                    .details-section .full-line {
                                        text-align: left; /* Center align the text */
                                        font-size: 0.9rem; /* Adjust font size for readability */
                                        font-weight: bold; /* Bold text for emphasis */
                                        text-transform: uppercase; /* Ensure the text is all caps */
                                        width: 100%; /* Span the full width of the container */
                                        grid-column: 1 / -1; /* Make it span across both columns in the grid */
                                        margin-top: 0mm; /* Optional: Add spacing above for better layout */
                                        white-space: nowrap; /* Prevent wrapping to a new line */
                                    }    
                            </style>
                        </head>
                        <body>
                            <div class="label">

                                   <div class="header-row">
                                        <!-- Logo -->
                                        <div class="container">
                                            <!-- Logo Section -->
                                            <div>
                                                <img 
                                                    src="${headerData.logo}" 
                                                    alt="Mill Logo" 
                                                    class="logo" 
                                                />
                                            </div>

                                            <!-- Text Details -->
                                            <div class="text-details">
                                                <p>PAPERBOARDS</p>
                                                <p>AND</p>
                                                <p>SPECIALTY</p>
                                                <p>PAPERS DIVISION</p>
                                            </div>
                                            
                                            
                                            
                                        </div>
                                            <!-- Marketed By Section -->
                                            <div class="marketed-by">
                                                <p>Marketed By:</p>
                                                <p>ITC Limited</p>
                                                <p>106, SP Road, Secunderabad</p>
                                                <p>Telangana - 500003</p>
                                                <p>Phone: 91-40-27846566-73</p>
                                            </div>
                                            
                                       
                            
                                   
                                </div>

                                
                                    

                                
                                    
                            
                                

                                   
                                

                                
                                
                                
                            </div>
                           
                        </body>
                        </html>
                    `);

                }


                // <h6>Size : ${size}</h6>
                // Close the print window and print the report
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }


        }



    };


       
                                    
//     <div class="details-section">
//     <div class="label">${reamdet.item_code}</div>
//     <div class="value"></div>

//     <div class="label" style="margin-right: 5mm;">GSM: ${reamdet.gsm}</div>
//     <div class="value"></div>

//     <div class="label">SIZE (cm): ${reamdet.size}</div>
//     <div class="value"></div>

//     <div class="label">NET WT (kg): ${reamdet.ream_weight}</div>
//     <div class="value"></div>     

//     <div class="label1">F.NO: ${reamdet.fno || 0}</div>
//     <div class="value"></div>    
// </div>

// <!-- Details Section -->
// <div class="details-section">                                  
//     <div class="label">DATE: ${formatDate(reamdet.shift_date)}</div>
//     <div class="value"></div>

//     <div class="label">LOT NO: <span style="font-weight: normal;">${reamdet.pr_number} </span>  </div>
//     <div class="value"><span style="font-weight: normal;"> / ${reamdet.cr_number}</span></div>

//     <div class="label">NO OF SHEET: ${reamdet.no_of_sheets || 0}</div>
//     <div class="value"></div>

//     <!-- Fixed for "MADE IN INDIA" -->
//     <div class="full-line">MADE IN INDIA</div>                              
// </div> 



    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    return (

        <>
            {ProductDetail.map((detail, index) => (
                <>
                    {company_id === '1' ? (<>
                        <Card sx={{ backgroundColor: "transparent", m: 2, padding: 1 }} >
                            <Box mb={1}>
                                <Typography variant="h5" textAlign="center">{t('prod_reams.ream_details')}</Typography>
                            </Box>
                            <Divider sx={{ marginBottom: "10px" }} />

                            <Grid container spacing={0} justifyContent="space-between" alignItems="center">
                                <Grid item xs={12} lg={8}>
                                    <Grid container spacing={0}>
                                        {/* Date and Shift */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{`DATE / SHIFT `}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={7}>
                                            <Typography variant="h7">: {` ${detail.shift_date || ''} / ${detail.shift_code || ''}`}</Typography>
                                        </Grid>

                                        {/* M.O No */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REAM NUMBER </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.ream_number}</Typography>
                                        </Grid>

                                        {/* M.A No */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">PALLET CODE </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.pallet_code}</Typography>
                                        </Grid>

                                        {/* Quantity */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REEL NUMBER </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.cr_number}</Typography>
                                        </Grid>

                                        {/* GSM */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">QUALITY </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={7}>
                                            <Typography variant="h7">: {detail.item_code}</Typography>
                                        </Grid>

                                        {/* No. Set */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">SIZE </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.size}</Typography>
                                        </Grid>

                                        {/* ID / OD */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">GSM </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.gsm}</Typography>
                                        </Grid>

                                        {/* TOTAL SHEETS */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REAM WEIGHT </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.ream_weight}</Typography>
                                        </Grid>

                                        {/* TOTAL SHEETS */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">NO.OF.SHEETS</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: {detail.no_of_sheets || 0}</Typography>
                                        </Grid>


                                        {/* SUPPLIER :*/}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REMARKS </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">: </Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                {/* QR Code */}
                                <Grid item xs={12} lg={4} textAlign="center">
                                    <Typography variant="h7">{detail.ream_number}</Typography>
                                    <QRCodeGenerator value={detail.ream_number} />
                                </Grid>
                            </Grid>



                            <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />

                            {hasPermission(userPermissions, "Ream Punching", "Print") && (
                                <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                    <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.ream_number)}>Print</Button>
                                </Box>
                            )}



                        </Card>
                    </>) : company_id === '13' ? (<>

                        <Card sx={{ backgroundColor: "#f5f5f5", m: 2, padding: 1 }} >
                            <Grid container justifyContent="flex" alignItems="center">
                                <Grid item xs={12} md={4} lg={2} xl={3}>

                                    <Grid container justifyContent="flex" alignItems="center">
                                        <Grid item xs={12} md={4} lg={0.1} xl={0.1}>
                                            <Box>
                                                <img
                                                    src={headerData.logo}
                                                    alt="Mill Logo"
                                                    style={{ maxWidth: '50px', height: 'auto', objectFit: 'contain' }} // Ensuring the logo scales properly
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={3} xl={4}>
                                            <Box marginLeft={7}>
                                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem' } }}>
                                                    PAPERBOARDS
                                                </Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem' } }}>
                                                    AND
                                                </Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem' } }}>
                                                    SPECIALTY
                                                </Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem' } }}>
                                                    PAPERS DIVISION
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={12} xl={12}>
                                            <Box mb={0} textAlign="center">
                                                <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem', xl: '0.6rem' } }}>Marketed By:</Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem', xl: '0.6rem' } }}>ITC Limited</Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem', xl: '0.6rem' } }}>106, SP Road, Secunderabad</Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem', xl: '0.6rem' } }}>Telangaa - 500003</Typography>
                                                <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.4rem', xl: '0.6rem' } }}>Phone: 91-40-27846566-73</Typography>
                                            </Box>
                                        </Grid>

                                    </Grid>


                                </Grid>
                                <Grid item xs={12} md={4} lg={4} xl={4}>
                                    <Box textAlign="left" marginLeft={2}>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>{detail.item_code}</Typography>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>GSM : {detail.gsm}</Typography>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>Size : {detail.size}</Typography>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>NET WEIGHT : {detail.ream_weight}</Typography>

                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={4} lg={4} xl={4}>
                                    <Box textAlign="left" marginLeft={2}>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>DATE : {formatDate(detail.shift_date)}</Typography>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>LOT NO : {detail.pr_number} /{detail.cr_number}</Typography>
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.8rem' } }}>NO OF SHEET : {detail.no_of_sheets || 0} </Typography>
                                        {/* , F.NO : {detail.fno} */}
                                        <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '1rem' } }}>MADE IN INDIA</Typography>

                                    </Box>
                                </Grid>
                            </Grid>


                            <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} />

                            {hasPermission(userPermissions, "Ream Punching", "Print") && (
                                <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                    <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.ream_number)}>Print</Button>
                                </Box>
                            )}

                        </Card>

                    </>) : null}
                </>
            ))}
        </>
    );

}
export default LabelReamDetails;